import React from "react";
import { Card } from "../modules/Settings/Prices";

export function PriceCardPage(props) {
  return <Card {...props} />;
}
